import React from 'react';
import { Loader, BaasicSelect } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const MarketplaceOrderEditAssignmentStepTemplate = ({
	t,
	marketplaceOrderEditViewStore: { form, loading, onSelectChange, carrierServiceOptions, warehouseOptions },
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<h3 className="spc--bottom--med title--primary">{t('MARKETPLACEORDEREDITFORM.TITLE.ASSIGNMENTSTEP')}</h3>
			<div className="row">
				<div className="col col-sml-12 col-lrg-12 col-xxlrg-8">
					<div className="row">
						<div className="col col-sml-6">
							<BaasicSelect
								field={form.$('assignmentStep.requiredWarehouse')}
								value={form.$('assignmentStep.requiredWarehouse').value}
								onChange={value => onSelectChange(value, form.$('assignmentStep.requiredWarehouse'))}
								options={warehouseOptions}
								isClearable={true}
								className="spc--bottom--sml flex--grow--1"
							/>
						</div>
						<div className="col col-sml-6">
							<BaasicSelect
								field={form.$('assignmentStep.requiredCarrierService')}
								value={form.$('assignmentStep.requiredCarrierService').value}
								onChange={value => onSelectChange(value, form.$('assignmentStep.requiredCarrierService'))}
								options={carrierServiceOptions}
								isClearable={true}
								className="spc--bottom--sml flex--grow--1"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default defaultTemplate(MarketplaceOrderEditAssignmentStepTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/wizard/MarketplaceOrderEditAssignmentStepTemplate.jsx